import DashboardLayoutWrapper from './layouts/DashboardLayoutWrapper';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import './translation/i18n';
import { ApiTranslationsProvider } from './context/ApiTranslationsContext';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <ApiTranslationsProvider>
              <DashboardLayoutWrapper />
            </ApiTranslationsProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}